export default "__VITE_ASSET__CrHdT9A1__"